import {
  FETCH_CLAIMS_REQUEST,
  FETCH_CLAIMS_SUCCESS,
  FETCH_CLAIMS_FAILURE,
  REVIEW_CLAIM_REQUEST,
  REVIEW_CLAIM_SUCCESS,
  REVIEW_CLAIM_FAILURE,
} from "./types";

import { fetchAllClaims, reviewClaim } from "../../services/claimService";


export const fetchClaimsRequest = () => ({
  type: FETCH_CLAIMS_REQUEST,
});

export const fetchClaimsSuccess = (data) => ({
  type: FETCH_CLAIMS_SUCCESS,
  payload: data,
});

export const fetchClaimsFailure = (error) => ({
  type: FETCH_CLAIMS_FAILURE,
  payload: error,
});

export const fetchClaimsAction = (page = 1, size = 10) => async (dispatch) => {
  dispatch(fetchClaimsRequest());

  try {
    const response = await fetchAllClaims(page, size);

    if (response.success) {
      dispatch(fetchClaimsSuccess(response.data));
    } else {
      dispatch(fetchClaimsFailure(response.error));
    }

    return response;
  } catch (error) {
    dispatch(fetchClaimsFailure(error.message));
    return { success: false, error: error.message };
  }
};


export const reviewClaimRequest = () => ({
  type: REVIEW_CLAIM_REQUEST,
});

export const reviewClaimSuccess = (updatedClaim) => ({
  type: REVIEW_CLAIM_SUCCESS,
  payload: updatedClaim,
});

export const reviewClaimFailure = (error) => ({
  type: REVIEW_CLAIM_FAILURE,
  payload: error,
});

export const reviewClaimAction = (claimId, payload) => async (dispatch) => {
  dispatch(reviewClaimRequest());

  try {
    const response = await reviewClaim(claimId, payload);

    if (response.success) {
      dispatch(reviewClaimSuccess(response.data));
    } else {
      dispatch(reviewClaimFailure(response.error));
    }

    return response;
  } catch (error) {
    dispatch(reviewClaimFailure(error.message));
    return { success: false, error: error.message };
  }
};